import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAnAggregatorOnboardingParameters = async ({
  customer_id,
  productType,
  documentOwnerType,
  sourceAppId,
}) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.GET_AN_AGGREGATOR_ONBOARDING_DETAILS_MULTIPLE}?customer_id=${customer_id}&productType=${productType}&documentOwnerType=${documentOwnerType}&source_app_id=${sourceAppId}`,
  );
  return data;
};

export default function useAnAggregatorOnboardingParameters({
  customer_id,
  productType,
  documentOwnerType,
  sourceAppId,
}) {
  return useQuery(
    [
      { customer_id, productType, documentOwnerType, sourceAppId },
      "getAnAggregatorOnboardingParameters",
    ],
    getAnAggregatorOnboardingParameters,
    {
      refetchOnWindowFocus: true,
    },
  );
}
